import classNames from "classnames";

import Icon from "../Utils/Icon";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";

const ParticipativeModuleCardThumb = props => {
  const { isNonDesktop } = useResponsiveFlag();
  const { thumbUrl } = props;

  const className = classNames([
    "d-flex",
    "align-items-center",
    "justify-content-center",
    "participative-module-card-thumb",
    props.className,
    {
      "margin-right-xs": isNonDesktop
    }
  ]);

  // Display icon if thumbUrl is blank
  const iconClassName =
    !thumbUrl &&
    classNames(
      "participative-module-card-thumb-icon",
      "text-primary",
      props.iconClassName
    );

  return (
    <div className={className}>
      {thumbUrl ? (
        <img src={thumbUrl} className="participative-module-card-thumb-image" />
      ) : (
        <Icon className={iconClassName} />
      )}
    </div>
  );
};

export default ParticipativeModuleCardThumb;
